import { Loader2, FileText } from "lucide-react";

/**
 * Full-screen blocking overlay shown while a PDF is being generated server-side.
 * PDF rendering (esp. multi-certificate job reports) is slow, so this gives the
 * user clear feedback that work is in progress.
 */
export default function PdfLoadingOverlay({ open, message }) {
  if (!open) return null;
  return (
    <div
      data-testid="pdf-loading-overlay"
      className="fixed inset-0 z-[100] flex items-center justify-center bg-[#33424f]/70 backdrop-blur-sm"
    >
      <div className="bg-[#f5f1ec] border border-[#33424f]/30 shadow-2xl px-8 py-7 max-w-sm mx-4 text-center">
        <div className="relative inline-flex items-center justify-center mb-4">
          <Loader2 className="w-12 h-12 text-[#39678f] animate-spin" />
          <FileText className="w-5 h-5 text-[#33424f] absolute" />
        </div>
        <div className="font-display text-xl tracking-tight text-[#33424f]">Generating PDF…</div>
        <p className="font-body text-sm text-[#50493b] mt-2">
          {message || "This can take a few moments for complex reports. Please keep this tab open."}
        </p>
      </div>
    </div>
  );
}
